import {
  MdKeyboardDoubleArrowDown,
  MdOutlineKeyboardDoubleArrowRight,
} from 'react-icons/md';

export const DoubleDownArrowsIcon = MdKeyboardDoubleArrowDown;
export const DoubleArrowRightIcon = MdOutlineKeyboardDoubleArrowRight;
